import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchSalesCreditNote = async (query) => {
  const { data } = await apiClient.get(`/sales-credit-notes/${query.queryKey[1]}`);
  return data;
};

export const fetchPurchaseCreditNote = async (query) => {
  const { data } = await apiClient.get(`/purchase-credit-notes/${query.queryKey[1]}`);
  return data;
};

export const useGetCreditNoteHandler = (id, isPurchase = false) => {
  const dispatch = useDispatch();
  const [creditNote, setCreditNote] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [isPurchase ? 'purchase-credit-note' : 'sales-credit-note', id], // A unique key for this query
    queryFn: isPurchase ? fetchPurchaseCreditNote : fetchSalesCreditNote,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setCreditNote(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    creditNote,
    isLoading,
  };
};
